export const setUsetiful = () => {
  const localStorageValue = localStorage.getItem("token");
  let script = document.getElementById("usetifulScript");
  const isTokenPresent = localStorageValue && localStorageValue !== "null";
  if (!script && isTokenPresent) {
    script = document.createElement("script");
    script.id = "usetifulScript";
    script.async = true;
    script.dataset.token = "8043f62538f25e1d2d7d0d0f04729f94";
    script.src = "https://www.usetiful.com/dist/usetiful.js";
    document.body.appendChild(script);
  } else if (script && !isTokenPresent) {
    window.location.reload();
  }
};
